module.exports = __webpack_public_path__ + "img/slider2.87c453a.jpg";